import { useState } from 'react';
import { Link } from 'react-router-dom';
import type { MinicrmProposal } from '../../../types/minicrmMigration';
import { useMinicrmMigrationStore } from '../../../store/minicrmMigrationStore';
import { ChangeMatchModal } from './ChangeMatchModal';

interface Props { proposals: MinicrmProposal[]; onChanged: () => void; }

export function ProposalTable({ proposals, onChanged }: Props) {
  const { decideContact } = useMinicrmMigrationStore();
  const [changeFor, setChangeFor] = useState<MinicrmProposal | null>(null);

  return (
    <>
      <table className="w-full text-sm border-collapse">
        <thead className="bg-gray-50 text-xs text-gray-600 uppercase">
          <tr>
            <th className="text-left px-3 py-2">Mini name</th>
            <th className="text-left px-3 py-2">Mini school</th>
            <th className="text-left px-3 py-2">Action</th>
            <th className="text-left px-3 py-2">Proposed Person / Org</th>
            <th className="text-right px-3 py-2">Acts</th>
            <th className="text-left px-3 py-2">Status</th>
            <th className="text-left px-3 py-2"></th>
          </tr>
        </thead>
        <tbody>
          {proposals.map((p) => (
            <tr key={p.id} className="border-t hover:bg-gray-50">
              <td className="px-3 py-2">{p.miniContactSnapshot.firstName} {p.miniContactSnapshot.lastName}</td>
              <td className="px-3 py-2 text-gray-600">{p.miniContactSnapshot.school ?? '—'}</td>
              <td className="px-3 py-2">{p.proposedAction}{p.blockedReason ? ' ⛔' : ''}</td>
              <td className="px-3 py-2">
                {p.proposedPerson ? (
                  <Link className="text-blue-600 hover:underline" to={`/people/${p.proposedPerson.id}`}>{p.proposedPerson.firstName} {p.proposedPerson.lastName}</Link>
                ) : p.proposedOrg ? (
                  <span className="text-gray-500">create @ {p.proposedOrg.name}</span>
                ) : (
                  <span className="text-gray-400">— create —</span>
                )}
              </td>
              <td className="px-3 py-2 text-right">{p.activityCount}</td>
              <td className="px-3 py-2">
                <span className="text-xs font-mono">
                  {p.commitStatus === 'COMMITTED' ? '✓ committed' :
                   p.commitStatus === 'FAILED' ? `✗ ${p.commitErrorMessage ?? 'failed'}` :
                   p.commitStatus === 'COMMITTING' ? '⏳ committing…' : p.decision}
                </span>
              </td>
              <td className="px-3 py-2">
                <div className="flex gap-2">
                  <button type="button" className="text-xs px-2 py-1 rounded bg-gray-100 hover:bg-gray-200 disabled:opacity-40" disabled={p.commitStatus === 'COMMITTED'} onClick={async () => { await decideContact(p.id, 'SKIPPED'); onChanged(); }}>Skip</button>
                  <button type="button" className="text-xs px-2 py-1 rounded bg-amber-50 text-amber-700 hover:bg-amber-100 disabled:opacity-40" disabled={p.commitStatus === 'COMMITTED'} onClick={() => setChangeFor(p)}>Change match</button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {changeFor && <ChangeMatchModal proposal={changeFor} onClose={() => { setChangeFor(null); onChanged(); }} />}
    </>
  );
}
